<div class="cd-multiple-accordion">
  <ng-content></ng-content>
</div>
